import { useEffect } from "react";
import "./styles/tokens.css";
import "./styles/forms.css";
import "./styles/tones.css";
import "./main.css";
import "./mobile.css";
import Routing from "./Routing";
import { SnackbarProvider, useSnackbar } from 'notistack';
import { messaging } from "./firebase";
import { getToken, onMessage, isSupported } from "firebase/messaging";
import { saveWebFCMToken } from "./services/StackHolderQueryService";

function AppContent() {
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    const initFCM = async () => {
      if (!localStorage.getItem("token")) {
        return;
      }
      try {
        const supported = await isSupported();
        if (!supported) {
          return;
        }

        // Request permission and get the token
        const currentToken = await getToken(messaging, {
          vapidKey: "BD91TurAf_uhsgSYTN0U59Fbgz_NNsIStS27atCTgqjw8FUXXB_omtdWFKCBFCFFolW7-O7IZX_zv2ysxFxE4fM"
        });

        if (currentToken) {
          await saveWebFCMToken(currentToken);
        }
      } catch (error) {
        if (error.code !== 'messaging/permission-blocked') {
          console.error("An error occurred while retrieving FCM token:", error);
        }
      }

      // Listen for foreground messages
      onMessage(messaging, (payload) => {
        enqueueSnackbar(`${payload.notification?.title || 'Notification'}: ${payload.notification?.body || ''}`, {
          variant: "info"
        });
      });
    };

    initFCM();
  }, [enqueueSnackbar]);

  return <Routing />;
}

function App() {
  return (
    <SnackbarProvider
      autoHideDuration={3000}
      transitionDuration={500}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      maxSnack={1}
      preventDuplicate>
      <AppContent />
    </SnackbarProvider>
  );
}

export default App;
